(function(){

    var triggers = document.querySelectorAll('[schedule-trigger]'),
        maxTrigger = triggers.length;

    if (!triggers) {
        return false;
    }

    for (var index = 0; index < maxTrigger; index++) {
        triggers[index].addEventListener('click', function(e){

            var el = this,
                clicked = false;
                scrollTop = $(el).offset().top - 115;


            $([document.documentElement, document.body]).stop().animate({
                scrollTop: scrollTop
            }, 1000);


            if (el.classList.contains('is-active')) {
                clicked = true;
            }

            for (var index = 0; index < maxTrigger; index++) {
                triggers[index].classList.remove('is-active');
            }

            if ( clicked == false) {
                el.classList.add('is-active');
            }
        });
    }

}())
